// Responsive table div wrapper
(function ($, Drupal) {
  Drupal.behaviors.hcwhGlobalJS = {
    attach: function (context) {
      // Responsive Tables
      once("textContent", ".c-rich-text", context).forEach(
        function (content) {
          const tables = $(content).find("table");
          tables.each(function () {
            const table = $(this);
            const responsiveTableDiv = $("<div>").addClass("table-wrapper");
            table.wrap(responsiveTableDiv);
          });
        }
      );
      // Smooth Scroll Anchor Links
      // function smoothScrollingTo(target) {
      //   $('html,body').animate({ scrollTop: $(target).offset().top }, 450);
      // }
      // $('a[href^=\\#]').on('click', function (event) {
      //   event.preventDefault();
      //   smoothScrollingTo(this.hash);
      // });
      // $(document).ready(function () {
      //   smoothScrollingTo(location.hash);
      // });

    },
  };
})(jQuery, Drupal);